import { render, staticRenderFns } from "./ChatSingle.vue?vue&type=template&id=308dd940&scoped=true"
import script from "./ChatSingle.vue?vue&type=script&lang=js"
export * from "./ChatSingle.vue?vue&type=script&lang=js"
import style0 from "./ChatSingle.vue?vue&type=style&index=0&id=308dd940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308dd940",
  null
  
)

export default component.exports